function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512,256.204C512,114.571,397.429,0,256.202,0   C114.579,0,0,114.571,0,256.204C0,397.429,114.579,512,256.202,512C397.429,512,512,397.429,512,256.204L512,256.204z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4CDBC4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 321.046,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#324A5E"
    },
    width: 268.533,
    x: 121.737,
    y: 95.478
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.073,195.329c3.576,0,6.764,3.187,6.764,7.162v27.452   c0,3.575-3.188,6.763-6.764,6.763c-27.056,0-54.104,0-81.159,0c-3.979,0-6.764-3.188-6.764-6.763v-27.452   c0-3.976,2.784-7.162,6.764-7.162C188.97,195.329,216.018,195.329,243.073,195.329L243.073,195.329z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FD8469"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.927,195.329h27.85c3.586,0,6.765,3.187,6.765,7.162   v27.452c0,3.575-3.179,6.763-6.765,6.763h-27.85c-3.576,0-6.755-3.188-6.755-6.763v-27.452   C262.172,198.516,265.351,195.329,268.927,195.329L268.927,195.329z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFD05B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.64,195.329h27.446c3.98,0,7.159,3.187,7.159,7.162v27.452   c0,3.575-3.179,6.763-7.159,6.763H322.64c-3.586,0-6.765-3.188-6.765-6.763v-27.452   C315.875,198.516,319.054,195.329,322.64,195.329L322.64,195.329z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FD8469"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.914,247.842h27.455c3.972,0,6.764,3.188,6.764,6.765   v27.849c0,3.585-2.792,6.764-6.764,6.764h-27.455c-3.979,0-6.764-3.179-6.764-6.764v-27.849   C155.15,251.029,157.935,247.842,161.914,247.842L161.914,247.842z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.623,247.842h27.45c3.576,0,6.764,3.188,6.764,6.765   v27.849c0,3.585-3.188,6.764-6.764,6.764h-27.45c-3.977,0-7.163-3.179-7.163-6.764v-27.849   C208.46,251.029,211.646,247.842,215.623,247.842L215.623,247.842z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.927,247.842h27.85c3.586,0,6.765,3.188,6.765,6.765   v27.849c0,3.585-3.179,6.764-6.765,6.764h-27.85c-3.576,0-6.755-3.179-6.755-6.764v-27.849   C262.172,251.029,265.351,247.842,268.927,247.842L268.927,247.842z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.64,247.842h27.446c3.98,0,7.159,3.188,7.159,6.765v27.849   c0,3.585-3.179,6.764-7.159,6.764H322.64c-3.586,0-6.765-3.179-6.765-6.764v-27.849   C315.875,251.029,319.054,247.842,322.64,247.842L322.64,247.842z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.914,300.362h27.455c3.972,0,6.764,3.178,6.764,6.756   v27.85c0,3.58-2.792,6.763-6.764,6.763h-27.455c-3.979,0-6.764-3.183-6.764-6.763v-27.85   C155.15,303.54,157.935,300.362,161.914,300.362L161.914,300.362z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.623,300.362h27.45c3.576,0,6.764,3.178,6.764,6.756v27.85   c0,3.58-3.188,6.763-6.764,6.763h-27.45c-3.977,0-7.163-3.183-7.163-6.763v-27.85C208.46,303.54,211.646,300.362,215.623,300.362   L215.623,300.362z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.927,300.362h27.85c3.586,0,6.765,3.178,6.765,6.756v27.85   c0,3.58-3.179,6.763-6.765,6.763h-27.85c-3.576,0-6.755-3.183-6.755-6.763v-27.85C262.172,303.54,265.351,300.362,268.927,300.362   L268.927,300.362z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.914,352.874h27.455c3.972,0,6.764,2.779,6.764,6.764   v27.446c0,3.981-2.792,6.76-6.764,6.76h-27.455c-3.979,0-6.764-2.778-6.764-6.76v-27.446   C155.15,355.653,157.935,352.874,161.914,352.874L161.914,352.874z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.623,352.874h27.45c3.576,0,6.764,2.779,6.764,6.764   v27.446c0,3.981-3.188,6.76-6.764,6.76h-27.45c-3.977,0-7.163-2.778-7.163-6.76v-27.446   C208.46,355.653,211.646,352.874,215.623,352.874L215.623,352.874z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.927,352.874h27.85c3.586,0,6.765,2.779,6.765,6.764   v27.446c0,3.981-3.179,6.76-6.765,6.76h-27.85c-3.576,0-6.755-2.778-6.755-6.76v-27.446   C262.172,355.653,265.351,352.874,268.927,352.874L268.927,352.874z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.245,387.084c0,3.981-3.179,6.76-7.159,6.76H322.64   c-3.586,0-6.765-2.778-6.765-6.76c0-26.652,0-53.31,0-79.966c0-3.578,3.179-6.756,6.765-6.756h27.446   c3.98,0,7.159,3.178,7.159,6.756C357.245,333.774,357.245,360.432,357.245,387.084L357.245,387.084z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F9B54C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 51.319,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E6E9EE"
    },
    width: 231.93,
    x: 140.035,
    y: 116.961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.096,126.905c3.183,0,5.571,1.192,7.562,3.187l0,0l0,0   c1.986,1.591,3.179,4.373,3.179,7.162v7.957c0,2.781-1.192,5.563-3.179,7.557c-1.99,1.988-4.379,3.181-7.562,3.181   c-2.779,0-5.571-1.192-7.558-3.181l0,0c-1.591-1.994-2.783-4.775-2.783-7.557v-7.957c0-2.789,1.192-5.571,2.783-7.162   C342.524,128.097,345.316,126.905,348.096,126.905L348.096,126.905L348.096,126.905z M352.874,132.476L352.874,132.476   c-1.192-1.192-2.788-1.986-4.778-1.986c-1.587,0-3.576,0.794-4.773,1.986c-1.192,1.192-1.989,3.18-1.989,4.777v7.957   c0,1.985,0.797,3.577,1.989,4.77c1.197,1.192,2.787,1.994,4.773,1.994c1.99,0,3.586-0.802,4.778-1.994s1.986-2.784,1.986-4.77   v-7.957C354.86,135.656,354.066,133.668,352.874,132.476L352.874,132.476L352.874,132.476z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#324A5E"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.652f5c8abc81fc05e981710abcc1fe5a.svg";
export { ForwardRef as ReactComponent };